import { render, staticRenderFns } from "./FormStock.vue?vue&type=template&id=92041304&scoped=true"
import script from "./FormStock.vue?vue&type=script&lang=js"
export * from "./FormStock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92041304",
  null
  
)

export default component.exports